export default __webpack_public_path__ + "static/media/we_collection.904e1631.jpeg";